module.exports = __webpack_public_path__ + "img/10-1.96f2ccfd.png";